import { render, staticRenderFns } from "./CaseToastNotification.vue?vue&type=template&id=bad05c6a&scoped=true&"
import script from "./CaseToastNotification.vue?vue&type=script&lang=js&"
export * from "./CaseToastNotification.vue?vue&type=script&lang=js&"
import style0 from "./CaseToastNotification.vue?vue&type=style&index=0&id=bad05c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad05c6a",
  null
  
)

export default component.exports